export const QA_SUBMENU_BUILT_IN_PLACEMENTS = {
  leftTop: {
    points: ['tr', 'tl'],
    overflow: { adjustX: 0, adjustY: 0 },
    offset: [0, 0],
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: { adjustX: 0, adjustY: 0 },
    offset: [0, 0],
  },
};
